module.exports = __webpack_public_path__ + "img/icon_map_10_off_001.f47d6f27.png";